// extracted by mini-css-extract-plugin
export default {"innerAlign":"innerAlign--mp-e07v7"};